import palette from "../palette"

export default {
  root: {
    backgroundColor: "#FFFFFF",
    "&$selected": {
      backgroundColor: palette.background.default,
    },
    "&$hover": {
      "&:hover": {
        backgroundColor: palette.background.default,
      },
    },
  },
}
